import React, { useRef, useState } from 'react';
import './forgot-password.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import { Link, useNavigate } from 'react-router-dom';
import { ModalAlert } from '@/components/modal/modal.component';
import { UseCloudFunction } from '@/utils/firebase.utils';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

const ForgotPasswordPage = () => {

    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const navigate = useNavigate();
    const approveRef = useRef();

    async function sendResetLink() {
        const email = document.getElementById('email').value.toLowerCase().replace(/\s+/g, '');
        console.log(email);
        if (!email.includes('@') || !email.includes('.')) {
            setAlertMessage('Please enter a valid email address.');
            return;
        }
        setLoading(true);
        const res = await UseCloudFunction(
            'sendPasswordResetEmail',
            { 'userEmail': email }
        )
        console.log(res);
        setLoading(false);
        if (res.error) {
            setAlertMessage(`Something went wrong. Please try again. (Error: ${res.error})`);
            return;
        }
        setAlertMessage('Password reset link sent to your email address. It could take a couple of minutes for you to receive it. Please check your inbox.');
        approveRef.current = () => {
            navigate('/signin')
        }
    }

    return (
        <div className='forgot-password-page'>
            <UnauthLayout>
                <div className='forgot-password-page__container g-card'>
                    <div className='card-title'>Forgot Password</div>
                    <hr />
                    <p>Enter your email address to reset your password.</p>
                    <div className='field small'>
                        <input 
                            type='email' 
                            id='email' 
                            name='email'
                            placeholder='your-email@email.com...' 
                            required />
                    </div>
                    <div className="g-space-1"></div>
                    {
                        (loading) 
                        ?
                        <div className='buttons'>
                            <button 
                                className='g-button'>
                                Cancel
                            </button>
                            <button className='g-button'>
                                <ThreeDotsLoader />
                            </button>
                        </div>
                        :
                        <div className='buttons'>
                            <Link to='/signin'>
                                <button 
                                    className='g-button'>
                                    Cancel
                                </button>
                            </Link>
                            <button 
                                className='g-button primary'
                                onClick={() => sendResetLink()} >
                                Send Reset Link
                            </button>
                        </div>
                    }
                </div>
            </UnauthLayout>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage}
                onApprove={approveRef.current} />
        </div>
    )
}

export default ForgotPasswordPage